import { defineTrpcContract, mutation, query } from "@amtana/module";

import {
  countSchema,
  emptyInputSchema,
  filterListSchema,
  filterListsSchema,
  listDefinitionSchema,
  listIdInputSchema,
  listIdsInputSchema,
  moveListsInputSchema,
  updateListInputSchema,
} from "./list.schemas.ts";

export const listTrpcContract = defineTrpcContract("list", {
  list: query({ input: emptyInputSchema, output: filterListsSchema }),
  get: query({ input: listIdInputSchema, output: filterListSchema }),
  create: mutation({ input: listDefinitionSchema, output: filterListSchema }),
  update: mutation({ input: updateListInputSchema, output: filterListSchema }),
  rebuild: mutation({ input: listIdsInputSchema, output: countSchema }),
  remove: mutation({ input: listIdsInputSchema, output: countSchema }),
  moveToProject: mutation({ input: moveListsInputSchema, output: countSchema }),
});
